import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeExternalLinks from 'rehype-external-links';
import {
  StyledIterationSummary,
  IterationSummaryDisclaimer
} from './IterationSummary.style';
import Header from './Header';
import { SECTIONS, EXCLUDE_SECTIONS } from './IterationSummary.consts';
import ListSkeleton from './ListSkeleton';
import { LineSkeleton } from 'components/base/Skeletons';
import Feedback from './Feedback';
import {
  IterationSummaryProps,
  IterationSummaryItem
} from './iteration-summary.model';
import { useHandleSharedLink } from './useHandleSharedLink';
import useIterationSummaryEventsTracker from './useIterationSummaryEventsTracker';

const IterationSummary = ({ iterationSummary }: IterationSummaryProps) => {
  const { data, isLoading } = iterationSummary ?? {};

  const trackingEventsHandler = useIterationSummaryEventsTracker({
    insightId: data?.insight_id
  });

  useHandleSharedLink({ trackingEventsHandler, inisghtId: data?.insight_id });

  if (isLoading) {
    return (
      <StyledIterationSummary>
        <Header
          data={data}
          isShareable={false}
          trackingEventsHandler={trackingEventsHandler}
        />
        <ListSkeleton />
        <LineSkeleton size={40} />
      </StyledIterationSummary>
    );
  }

  return (
    <StyledIterationSummary>
      <Header data={data} trackingEventsHandler={trackingEventsHandler} />
      <main>
        {data?.accomplishments
          .filter(
            item =>
              !item.type || (item.type && !EXCLUDE_SECTIONS.includes(item.type))
          )
          .map((item: IterationSummaryItem, index: number) => (
            <div key={index}>
              <Markdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}
              >
                {item.content ? String(item.content) : String(item)}
              </Markdown>
            </div>
          ))}
        <IterationSummaryDisclaimer>
          This was generated by AI, so mistakes are possible. Verify for
          accuracy before use.
        </IterationSummaryDisclaimer>
      </main>
      <Feedback
        section={SECTIONS.ACCOMPLISHMENTS}
        trackingEventsHandler={trackingEventsHandler}
      />
    </StyledIterationSummary>
  );
};

export default IterationSummary;
